import { ApplicationRef, ChangeDetectorRef, Component, inject, NgZone, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { IdmUtilities } from '@platform-idm/sdk-javascript';
import { PlatformIdmService } from '@platform-idm/sdk-angular';
import { Alert, AlertType } from './shared/alert.model';
import { AlertTypes, MessageService, MessageType } from './shared/message.service';
import { VirtualKeyboardService } from './shared/VirtualKeyboardService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'login-frontend';
  alert: Alert;
  alertClass: string;
  processing = false;

  private cdr: ChangeDetectorRef;
  private ngZone: NgZone;
  constructor(private auth: PlatformIdmService, private messages: MessageService, private appRef: ApplicationRef, private virtualKeyboard: VirtualKeyboardService) {
    this.cdr = inject(ChangeDetectorRef);
    this.ngZone = inject(NgZone);

    console.log("refer", this.getReferrer());

    const debug = window.location.href.indexOf("debug=true") >= 0;

    let link: HTMLLinkElement = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `${environment.cdnUrl}/idm/socialsso/styles.css`;
    document.head.appendChild(link);

    this.messages.get().subscribe((msg) => {
      if (msg === MessageType.ProcessingOn) {
        this.processing = true;
      } else if (msg === MessageType.ProcessingOff) {
        this.processing = false;
      }
    });


    if (debug) {

      const originalLog = console.log;
      const originalError = console.error;
      const originalWarning = console.warn;
      const originalDebug = console.debug;

      console.log = (...args) => {
        originalLog(...args);
        window.postMessage({ type: "log", message: args }, "*");
        alert("log:" + JSON.stringify(args));
      };
      console.debug = (...args) => {
        originalDebug(...args);
        window.postMessage({ type: "originalWarning", message: args }, "*");
        alert("debug:" + JSON.stringify(args));
      };

      console.warn = (...args) => {
        originalWarning(...args);
        window.postMessage({ type: "warning", message: args }, "*");
        alert("warning:" + JSON.stringify(args));
      };

      console.error = (...args) => {
        originalError(...args);
        window.postMessage({ type: "error", message: args }, "*");
        alert("error:" + JSON.stringify(args));
      };
    }
  }

  private startAlertTimer() {
    setTimeout(() => {
      this.alert = null;
    }, 3000);
  }

  private clearErrorAlert() {
    if (this.alert && this.alert.type == AlertType.DANGER) {
      this.alert = null;
    }
  }

  private getReferrer() {
    let uti = new IdmUtilities();
    let referrer = uti.getQueryVariable("referrer");
    if (!referrer)
      referrer = document.referrer;

    return referrer;

  }
  utility = new IdmUtilities();

  async ngOnInit() {

    //If this cookie is set, it means we got here after the security-questions screen
    //which means, we got redirect back to the app again and then back here
    //The app may be redirecting here may be sending the default value for the VK instead of the selected by the user.
    if (this.utility.readCookie("mx1.redirected-security-questions") != "true") {
      if (this.utility.getQueryVariable("showOnscreenKeyboard") != "") {
        this.virtualKeyboard.saveShowOnscreenKeyboard(this.utility.getQueryVariable("showOnscreenKeyboard") == "true", this.utility.getQueryVariable("onscreenKeyboardEnabled")=="true");
      }
    }

    this.virtualKeyboard.initialize();




    //if (this.virtualKeyboard.enabled)
    //  onscreenKeyboardEnabled = true;





    //if (this.virtualKeyboard.getShowOnscreenKeyboard())//override by cookie. if it was previously. ie login, vk enabled, redirect to sec questions
    //  showOnscreenKeyboard = true;



    await this.auth.configure();

    this.messages.get().subscribe((msg) => {

      //this timeout will prevent the ExpressionChangedAfterItHasBeenCheckedError:  error during development
      if (msg.isGenericMessage) {


        if (msg.type === AlertTypes.Success) {
          this.alert = new Alert(AlertType.SUCCESS, msg.message);
          this.alertClass = "alert-success";
          this.startAlertTimer();
        }
        else if (msg.type === AlertTypes.Warning) {
          this.alert = new Alert(AlertType.WARNING, msg.message);
          this.alertClass = "alert-warning";
          this.startAlertTimer();
        }
        else if (msg.type === AlertTypes.Error) {
          this.alert = new Alert(AlertType.DANGER, msg.message);
          this.alertClass = "alert-danger";
        }
        else if (msg.type === AlertTypes.Clear) {
          this.alert = null;
        }
        else if (msg.type === AlertTypes.ClearError) {
          this.clearErrorAlert();
        }
        return;
      }


      //if (msg === MessageType.Logout) {
      //  this.logout();
      //} else if (msg === MessageType.ProcessingOn) {
      //  this.processing = true;
      //} else if (msg === MessageType.ProcessingOff) {
      //  this.processing = false;
      //}
      //});


    });

  }
}
